import React from 'react';

import CoursePauseRescheduleModal from './CoursePauseRescheduleModal';
import CoursePauseScheduledTable from './CoursePauseScheduledTable';
import styles from './CoursePauseScheduledPage.module.scss';

function CoursePauseScheduledPage() {
  return (
    <div className={styles.root}>
      <CoursePauseScheduledTable />
      <CoursePauseRescheduleModal />
    </div>
  );
}

export default CoursePauseScheduledPage;
